var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.23 12.2C12.0666 10.0812 12.5563 7.96311 13.633 6.13095C14.7098 4.29879 16.322 2.84047 18.2526 1.95228C20.1833 1.06409 22.3396 0.788673 24.4315 1.16309C26.5234 1.53751 28.4504 2.54379 29.9531 4.04649C31.4558 5.5492 32.4621 7.47618 32.8365 9.56808C33.211 11.66 32.9355 13.8164 32.0473 15.747C31.1592 17.6776 29.7008 19.2898 27.8687 20.3666C26.0365 21.4434 23.9185 21.933 21.7996 21.7696",
    stroke: "url(#paint0_linear_23_1323)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 25C33 26.273 32.4943 27.4939 31.5941 28.3941C30.6939 29.2943 29.473 29.8 28.2 29.8H25M25 29.8L28.2 26.6M25 29.8L28.2 33M1 9C1 7.72696 1.50571 6.50606 2.40589 5.60589C3.30606 4.70571 4.52696 4.2 5.8 4.2H9M9 4.2L5.8 7.4M9 4.2L5.8 1M11.4 33C8.64175 33 5.99647 31.9043 4.04609 29.9539C2.09571 28.0035 1 25.3583 1 22.6C1 19.8417 2.09571 17.1965 4.04609 15.2461C5.99647 13.2957 8.64175 12.2 11.4 12.2C14.1583 12.2 16.8035 13.2957 18.7539 15.2461C20.7043 17.1965 21.8 19.8417 21.8 22.6C21.8 25.3583 20.7043 28.0035 18.7539 29.9539C16.8035 31.9043 14.1583 33 11.4 33Z",
    stroke: "url(#paint1_linear_23_1323)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_23_1323",
    x1: 32.9992,
    y1: 19.3044,
    x2: 11.8681,
    y2: 18.9138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB9B3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8664"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_23_1323",
    x1: 33,
    y1: 29.16,
    x2: 0.490611,
    y2: 28.5591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB9B3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8664"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/swap.ee7d528a75f980cb97ca5aaf8668057a.svg";
export { ForwardRef as ReactComponent };